// Single source of truth for the rejection-reason categories used by both the
// feed X-reject modal (OfferRejectReasonModal) and the chatbot-proposals reject
// modal (ChatbotRejectReasonModal), plus the proposals-page category label.
//
// Store the ENGLISH key in the DB; show the Hebrew label only. Mirrors
// rebase_server's ChatbotProposal::REJECTION_REASON_CATEGORIES allow-list.
export const REJECTION_CATEGORIES = [
  { key: 'experience', label: 'ניסיון' },
  { key: 'domain', label: 'תחום' },
  { key: 'role', label: 'תפקיד' },
  { key: 'salary', label: 'שכר' },
  { key: 'distance', label: 'מרחק' },
  { key: 'stability', label: 'יציבות' },
  { key: 'education', label: 'השכלה' },
  { key: 'language', label: 'שפה' },
  { key: 'external_info', label: 'מידע חיצוני', hint: 'סיבה שאינה בנתוני המועמד/משרה' },
  { key: 'recruiter_error', label: 'טעות מגייס' }
]

// English category KEY -> Hebrew label. Empty string for unknown/blank keys.
const LABEL_BY_KEY = REJECTION_CATEGORIES.reduce((acc, cat) => {
  acc[cat.key] = cat.label
  return acc
}, {})

export const rejectionCategoryLabel = (key) => LABEL_BY_KEY[key] || ''

// Sampling: asking for a reason on EVERY reject slowed recruiters down.
// 2026-08-02 (CEO request, Telegram "פרומפטים מבושלים"): the modal is fully
// disabled — every reject goes through immediately with no reason prompt.
// Set back to a value in (0,1] to re-enable sampling. Used by both the feed
// X-reject (offers_helper) and the chatbot-proposals page.
export const REJECTION_REASON_ASK_RATE = 0

export const shouldAskRejectionReason = () => Math.random() < REJECTION_REASON_ASK_RATE
